import React from 'react';
import PropTypes from 'prop-types';

import ConcertCardItem from '../concertCard/concertCard';

import './_concertCardList.scss';

function ConcertCardList ({ data }) {
  return (
    <div className='calendar-list'>
      {data && data.length
        ? data.map((concert, i) => {
          return (
            <ConcertCardItem
              name={concert.id}
              key={`concert-${concert.id}-${concert.slug}`}
              data={concert}
            />
          );
        }) : ''}
    </div>
  );
}

ConcertCardList.propTypes = {
  data: PropTypes.array,
};

export default ConcertCardList;
